import React, { useState, useEffect } from 'react'
import "./PackageDetails.css"
import { Hero, Details, Card } from '../../Features/PackageDetails'
import { Container, Row, Col } from 'react-bootstrap'
import { axiosGet } from '../../utils/apis/api'
import { SpinnerLoading,NotFound } from '../../components';
import { useTranslation } from '../../contexts/TranslationContext';
import { useGlobal } from '../../contexts/GlobalContext';




const PackageDetails = ({ url }) => {
  
  const { setPackageNotFound } = useGlobal();

  const [showModal, setShowModal] = useState(false);
  const pathSegments = window.location.pathname.split('/');
  const encodedPackageId = pathSegments[pathSegments.length - 1];
  const packageId = decodeURIComponent(encodedPackageId);
  const [packageData, setPackageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchPackageData = async () => {

      try {
        const data = await axiosGet(
          `${url}/api/method/alltimes.alltimes_travel.doctype.all_time_package.all_time_package.allTimePackage?package_id=${encodeURIComponent(packageId)}`
        );
        
       setPackageData(data.result);
       setPackageNotFound(false);
        
      } catch (err) {
        setError(err.message);
        setPackageNotFound(true);
        console.log("Error",error);
      } finally {
        setLoading(false);
      }
    };

    fetchPackageData();
   
  }, [packageId]);


  useEffect(()=>{
    console.log("SSSSSSSSSSSSSSSSSs")
    console.log(error)
  },[error])

  if (loading) return <div className='loading-package-details'><SpinnerLoading /></div>;
  // if (error) return <div>{t("Error")}: {error}</div>;
  // if (!packageData) return <div>{t("PackageNotFound")}</div>;
       console.log("error",error);
    if (error) 
      return (
 
    <NotFound
      errorCode={String( error?.status_code || "404")}
      errorMessage={String(
        error || t("NoResultsFound")
      )}
      description={String(
        error?.message || t("NoResultsFoundText")
      )}
    />
  );

  return (
    <div>
      <Hero packageData={packageData} url={url} />
      <Container className={`package-details-container`}>
        <Row>
          <Col lg={9}>
            <Details url={url} packageData={packageData} />
          </Col>
          <Col lg={3} className='card-sticky-container'>
            <div className="card-sticky">
              <Card url={url} packageId={packageId} packageData={packageData} />
            </div>
          </Col>
        </Row>
      </Container>

      {/* Floating Action Button */}
      <div 
        className='package-details-card-show' 
        onClick={() => setShowModal(true)} 
        style={{
          bottom: `${showModal ? '-60px' : '0'}`
        }}
      >
         {t("RequestYourPlan")}
      </div>

      {/* Backdrop Overlay */}
      <div
        className='overlay-drawer-package-details' 
        style={{
          opacity: showModal ? 1 : 0,
          pointerEvents: showModal ? 'auto' : 'none',
        }}
        onClick={() => setShowModal(false)}
      />

      {/* Bottom Drawer */}
      <div
        className='drawer-package-details'
        style={{
          transform: showModal ? 'translateY(0)' : 'translateY(100%)',
        }}
      >
        <button 
          className='drawer-package-details-close'
          onClick={() => setShowModal(false)}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#0F1729"></path> </g></svg>
        </button>
        <Card url={url} packageId={packageId} packageData={packageData} />
      </div>
    </div>
  )
}

export default PackageDetails;